import type { VoiceTranscriptionError } from "../../application/voice-transcription";

export const voiceErrorText: Record<VoiceTranscriptionError, string> = {
  unsupported: "На этом устройстве браузерное распознавание речи недоступно.",
  permission: "Разрешите YumNote доступ к микрофону в настройках браузера.",
  "no-speech": "Речь не распознана. Попробуйте говорить ближе к телефону.",
  network: "Служба распознавания браузера сейчас недоступна.",
  aborted: "Запись отменена.",
  unknown: "Не удалось распознать речь. Попробуйте ещё раз.",
};
